/* THE FOOT'S NET (P19-13; the owner, on a rail that had become a page's last block: "do something so that we never face this
   issue again"). THE FOOT EVERYWHERE (assets/svnty-foot.css) is written page by page, on each page's own last block, so a new
   section, a new order or a block that hides itself left a page ending on the footer. This net holds the law on every page
   without knowing the page: it finds the last thing the page PAINTS (text, a picture, a control, a card's own edge; never a
   full-width band, which meets the footer as a surface) and, when that stands closer to the footer than the law
   (--svnty-foot: 48 px on the phone, 64 from 750) by more than 6 px, it gives the page the missing room. It never takes room
   away, and a page already on the law is left alone (the sheets stay the exact, ink-true rule; this is the floor under them).
   It runs when the page has loaded and again whenever the page's height changes (a rail that arrives, a list that empties).
   A block that is MEANT to meet the footer says so: data-svnty-foot="none". No dependency; reads, then one write. */
(function () {
  if (window.__svntyFootNet) return; window.__svntyFootNet = true;
  var main = document.getElementById('MainContent'); if (!main) return;
  var root = document.documentElement, queued = false, pad = 0;
  var BOXED = { IMG: 1, SVG: 1, svg: 1, VIDEO: 1, CANVAS: 1, INPUT: 1, BUTTON: 1, SELECT: 1, TEXTAREA: 1, IFRAME: 1, PICTURE: 1 };
  function law() { var v = parseFloat(getComputedStyle(root).getPropertyValue('--svnty-foot')); return isFinite(v) ? v : 48; }
  function alpha(c) { var m = /rgba?\(([^)]+)\)/.exec(c || ''); if (!m) return 0; var p = m[1].split(/[,\/\s]+/).filter(Boolean); return p.length > 3 ? parseFloat(p[3]) : 1; }
  /* the foot of an element's own words: the BASELINE of its lowest line (the law's ink for text), from the line's box less its
     half leading and the face's descent (a fifth of the size); null when it holds no words of its own */
  function baseline(e, cs) {
    var low = null, n, rg, r, fs, lh, b;
    for (n = e.firstChild; n; n = n.nextSibling) {
      if (n.nodeType !== 3 || !/\S/.test(n.nodeValue)) continue;
      rg = document.createRange(); rg.selectNodeContents(n); r = rg.getBoundingClientRect(); if (!r.height) continue;
      fs = parseFloat(cs.fontSize) || 14; lh = parseFloat(cs.lineHeight); if (!isFinite(lh)) lh = fs * 1.2;
      b = r.bottom - Math.max(0, (lh - fs) / 2) - fs * 0.2;
      if (low === null || b > low) low = b;
    }
    return low;
  }
  function boxed(e, cs, r, vw) {
    if (BOXED[e.tagName]) return true;
    if (r.width >= vw - 1) return false;   /* a band from edge to edge is a surface, not the last ink */
    return (parseFloat(cs.borderBottomWidth) > 0 && alpha(cs.borderBottomColor) > 0) || alpha(cs.backgroundColor) > 0 || cs.backgroundImage !== 'none';
  }
  function ink(sec, vw) {
    var low = -Infinity, all = sec.getElementsByTagName('*'), i, e, r, cs, b;
    for (i = 0; i < all.length; i++) {
      e = all[i]; r = e.getBoundingClientRect();
      if (r.width <= 1.5 || r.height <= 1.5 || r.bottom <= low) continue;
      cs = getComputedStyle(e);
      if (cs.visibility !== 'visible' || cs.opacity === '0') continue;
      if (boxed(e, cs, r, vw)) { low = r.bottom; continue; }
      b = baseline(e, cs); if (b !== null && b > low) low = b;
    }
    return low;
  }
  function run() {
    queued = false;
    var vw = root.clientWidth, kids = main.children, i, sec, low = -Infinity, want = 0;
    for (i = kids.length - 1; i >= 0 && low === -Infinity; i--) {
      sec = kids[i];
      if (!sec.offsetHeight || sec.tagName === 'SCRIPT' || sec.tagName === 'STYLE') continue;
      if (sec.matches('[data-svnty-foot="none"]') || sec.querySelector('[data-svnty-foot="none"]')) { low = null; break; }
      low = ink(sec, vw);
    }
    if (low !== null && low !== -Infinity) {
      var gap = main.getBoundingClientRect().bottom - pad - low, need = law() - gap;
      want = need > 6 ? Math.round(need) : 0;
    }
    if (want === pad) return;
    pad = want;
    if (pad) { main.style.paddingBottom = pad + 'px'; main.setAttribute('data-svnty-foot-net', String(pad)); }
    else { main.style.paddingBottom = ''; main.removeAttribute('data-svnty-foot-net'); }
  }
  function ask() { if (queued) return; queued = true; requestAnimationFrame(run); }
  if (document.readyState === 'complete') ask(); else window.addEventListener('load', ask);
  document.addEventListener('DOMContentLoaded', ask);
  window.addEventListener('resize', ask, { passive: true });
  if (window.ResizeObserver) new ResizeObserver(ask).observe(main);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ask);
})();
